import { Task } from "gantt-task-react";

const ganttData: Task[] = [
  {
    start: new Date(2024, 0, 1, 7, 0, 0),
    end: new Date(2024, 1, 6, 10, 30, 0),
    name: "ERP Force Project",
    id: "sample",
    type: "project",
    progress: 30,
    isDisabled: false,
    hideChildren: false,
  },
  {
    start: new Date(2024, 0, 4, 7, 0, 0),
    end: new Date(2024, 0, 7, 10, 30, 0),
    name: "task 2",
    id: "Task 2",
    type: "task",
    progress: 70,
    isDisabled: false,
    project: "sample",
  },
  {
    start: new Date(2024, 0, 12, 7, 0, 0),
    end: new Date(2024, 0, 14, 10, 30, 0),
    name: "task 3",
    id: "Task 3",
    type: "task",
    progress: 60,
    dependencies: ["Task 2"],
    isDisabled: false,
    project: "sample",
  },
  {
    start: new Date(2024, 0, 14, 7, 0, 0),
    end: new Date(2024, 0, 16, 10, 30, 0),
    name: "task 4",
    id: "Task 4",
    type: "task",
    progress: 100,
    isDisabled: false,
  },
  {
    start: new Date(2024, 1, 4, 7, 0, 0),
    end: new Date(2024, 1, 6, 10, 30, 0),
    name: "completed",
    id: "Task 5",
    type: "milestone",
    dependencies: ["Task 2"],
    progress: 100,
    isDisabled: false,
    project: "sample",
  },
];
export default ganttData;
